import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, useRef } from "react";
import { RectangleBackground, StoryDataContent } from "@vfit/shared/components";
import { EffectCards, FreeMode, Keyboard, Mousewheel, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { useDeviceType } from "@vfit/shared/hooks";
import { getSlideSize } from "./CarouselStoriesExperience.utils";
import { StoryArticleContainer } from "./CarouselStoriesExperience.style";
import CarouselStoriesExperienceAnimation from "./components/CarouselStoriesExperienceAnimation/CarouselStoriesExperienceAnimation";
var CarouselStoriesExperience = function(param) {
    var enableAnimationBeforeScroll = param.enableAnimationBeforeScroll, configuration = param.configuration, action = param.action, storiesArticles = param.storiesArticles;
    var ref;
    var ref1 = useDeviceType(), isMobile = ref1.isMobile, isTablet = ref1.isTablet, isBigDesktop = ref1.isBigDesktop;
    var mainContainerRef = useRef(null);
    return /*#__PURE__*/ _jsx(RectangleBackground, {
        data: _object_spread({}, configuration),
        handleClick: function() {
            return action === null || action === void 0 ? void 0 : action();
        },
        containerRef: mainContainerRef,
        children: /*#__PURE__*/ _jsx(StoryArticleContainer, {
            children: /*#__PURE__*/ _jsxs(Swiper, {
                slidesPerView: "auto",
                effect: "slide",
                cardsEffect: {
                    rotate: true,
                    slideShadows: false
                },
                spaceBetween: 32,
                freeMode: false,
                mousewheel: {
                    forceToAxis: true
                },
                centeredSlides: isMobile,
                keyboard: true,
                pagination: {
                    bulletClass: "swiper-pagination-bullet-exp",
                    bulletActiveClass: "swiper-pagination-bullet-active-exp",
                    clickable: true
                },
                modules: [
                    Pagination,
                    FreeMode,
                    Mousewheel,
                    Keyboard,
                    EffectCards
                ],
                children: [
                    enableAnimationBeforeScroll && /*#__PURE__*/ _jsx(CarouselStoriesExperienceAnimation, {
                        containerRef: mainContainerRef
                    }),
                    Children.toArray((ref = StoryDataContent(storiesArticles)) === null || ref === void 0 ? void 0 : ref.map(function(StoryArticle, index) {
                        var marginLeft = 0;
                        if (index === 0) {
                            if (!isBigDesktop) marginLeft = 32;
                            else if (isBigDesktop) marginLeft = -80;
                        }
                        var customSize = getSlideSize(isMobile, isTablet);
                        return /*#__PURE__*/ _jsx(SwiperSlide, {
                            id: "".concat(index, "_carouselStoriesExp"),
                            style: _object_spread({
                                marginLeft: marginLeft
                            }, customSize),
                            children: StoryArticle
                        });
                    }))
                ]
            })
        })
    });
};
export default CarouselStoriesExperience;
